import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import { BbSelectNoFormik } from '../styling/bbInput';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { monitoringActions } from '../../store/monitoringStore';
import Message from '../common/message';
import ModalInner from '../layoutItems/modalInner';
import { selectDefaultStyles } from '../styling/selectDefaultStyles';

import './monitoring.scss';

const DEFAULT_VALUES = {
    portfolioToAdd: null,
    portfolioToRemove: null,
    label: "",
    newPortfolio: ""
}

const FORMS = {
    add: "add",
    remove: "remove",
    create: "create"
};

class AddToPortfolioPopup extends React.Component {
    state = {
        activeForm: null,
        validation: {
            message: null,
            messageType: null
        }
    }

    render() {
        var listToAdd = [];
        if (this.props.monitoring.addToPortfolioPopupData)
            listToAdd = this.props.monitoring.addToPortfolioPopupData.listToAdd;

        return (
            <ModalInner close={() => this.props.close()} title={this.props.translate("Monitoring.Add.AddToPortfolio")}>
                <Formik
                    initialValues={DEFAULT_VALUES}
                    enableReinitialize={true}
                >
                    {({ setFieldValue, values }) => (
                        <Form noValidate>
                            <table className="table table-report-section portfolio-popup-table" style={{ width: "100%" }}>
                                <colgroup>
                                    <col width="30%" />
                                    <col width="70%" />
                                </colgroup>
                                <tbody>
                                    {this.props.monitoring.message ?
                                        <tr>
                                            <td colSpan="2">
                                                <Message type={this.props.monitoring.messageType} options={{ renderInnerHtml: true }}
                                                    message={this.props.translate(this.props.monitoring.message, this.props.monitoring.messageData)}
                                                />
                                            </td>
                                        </tr> : null}
                                    {this.state.validation.message &&
                                        <tr>
                                            <td colSpan="2">
                                                <Message type={this.state.validation.messageType} message={this.state.validation.message} />
                                            </td>
                                        </tr>}
                                    {(this.props.subject.type === 1) ? <>
                                        <tr>
                                            <td><Translate id="Monitoring.Add.CompanyName" /></td>
                                            <td>{this.replaceEm(this.props.subject.name)}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Monitoring.Add.CompanyId" /></td>
                                            <td>{this.replaceEm(this.props.subject.ico)}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Monitoring.Add.CompanyAddress" /></td>
                                            <td>{this.props.subject.address}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Monitoring.Add.Nace" /></td>
                                            <td>{this.props.monitoring.addToPortfolioPopupData ? this.props.monitoring.addToPortfolioPopupData.nace : ""}</td>
                                        </tr>
                                    </> : <>
                                        <tr>
                                            <td><Translate id="Monitoring.Add.PersonName" /></td>
                                            <td>{this.replaceEm(this.props.subject.name)}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Monitoring.Add.DOB" /></td>
                                            <td>{this.props.subject.dateOfBirthFormated}</td>
                                        </tr>
                                        <tr>
                                            <td><Translate id="Monitoring.Add.PersonAddress" /></td>
                                            <td>{this.props.subject.address}</td>
                                        </tr>
                                    </>}
                                    {this.state.activeForm === FORMS.add && this.renderAddToPortfolioForm(listToAdd, setFieldValue)}
                                    {this.state.activeForm === FORMS.remove && this.renderRemoveFromPortfolioForm(setFieldValue)}
                                    {this.state.activeForm === FORMS.create && this.renderCreateNewPortfolio(setFieldValue)}
                                </tbody>
                            </table>
                            {this.state.activeForm === FORMS.add && <div style={{ textAlign: "center", fontWeight: "normal", marginTop: "1em", marginBottom: "1em" }}>
                                <Translate id="Monitoring.Add.Info" />
                            </div>}
                            {this.renderFormButtons(values, setFieldValue)}
                        </Form>
                    )}
                </Formik>
            </ModalInner>
        );
    }

    componentDidMount() {
        this.getData();
    }

    renderFormButtons = (values, setFieldValue) => {
        switch (this.state.activeForm) {
            case FORMS.add:
                return (
                    <div className="modal-inner-buttons">
                        <button type="button"
                            onClick={() => {
                                this.setState({ activeForm: null });
                                setFieldValue("portfolioToAdd", "");
                            }}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        >
                            <Translate id="Common.Back" />
                        </button>
                        <button type="button"
                            onClick={() => {
                                this.addSubject(values.portfolioToAdd, values.label);
                                setFieldValue("portfolioToAdd", "");
                            }}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                            disabled={isNullOrUndefined(values.portfolioToAdd) || values.portfolioToAdd <= 0}
                        >
                            <Translate id="Monitoring.Add.AddToPortfolio" />
                        </button>
                    </div>
                );
            case FORMS.remove:
                return (
                    <div className="modal-inner-buttons">
                        <button type="button"
                            onClick={() => {
                                this.setState({ activeForm: null });
                                setFieldValue("portfolioToRemove", "");
                            }}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        >
                            <Translate id="Common.Back" />
                        </button>
                        <button type="button"
                            onClick={() => {
                                this.removeSubject(values.portfolioToRemove);
                                setFieldValue("portfolioToRemove", "");
                            }}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                            disabled={isNullOrUndefined(values.portfolioToRemove)}
                        >
                            <Translate id="Monitoring.Add.RemoveFromPortfolio" />
                        </button>
                    </div>
                );
            case FORMS.create:
                return (
                    <div className="modal-inner-buttons">
                        <button type="button"
                            onClick={() => {
                                this.setState({ activeForm: FORMS.add });
                                setFieldValue("portfolioToAdd", "");
                                setFieldValue("newPortfolio", "");
                            }}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        >
                            <Translate id="Common.Back" />
                        </button>
                        <button type="button"
                            onClick={() => {
                                this.addSubject(null, values.label, values.newPortfolio);
                                setFieldValue("portfolioToAdd", "");
                                values.newPortfolio = null;
                            }}
                            disabled={isNullOrUndefined(values.newPortfolio) || values.newPortfolio === ""}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        >
                            <Translate id="Monitoring.Add.CreateNewPortfolio" />
                        </button>
                    </div>
                );
            default:
                return (
                    <div className="modal-inner-buttons">
                        <button type="button"
                            onClick={() => this.setState({ activeForm: FORMS.add })}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        >
                            <Translate id="Monitoring.Add.AddToPortfolio" />
                        </button>
                        <button type="button"
                            onClick={() => this.setState({ activeForm: FORMS.remove })}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}
                        >
                            <Translate id="Monitoring.Add.RemoveFromPortfolio" />
                        </button>
                    </div>
                );
        }
    }

    selectStyle = () => {
        var style = selectDefaultStyles;
        style.menuPortal = base => ({ ...base, zIndex: 99999999 });
        return style;
    }

    renderAddToPortfolioForm = (listToAdd, setFieldValue) => {
        return (
            <>
                <tr>
                    <td><Translate id="Monitoring.Add.SelectPortfolio" /></td>
                    <td>
                        <div>
                            <BbSelectNoFormik options={listToAdd.map(c => ({ label: c.name, value: c.listId, key: c.ListId }))}
                                onChange={(e) => setFieldValue("portfolioToAdd", e.value)}
                                selectPlaceholder={`${this.props.translate("Common.Select")} ...`}
                                noOptionsMessage={this.props.translate("Monitoring.NoPortfolios")}
                                isFixed={true}
                                style={this.selectStyle()}
                            />
                        </div>
                        <div>
                            <span className="link-internal" onClick={() => this.setState({ activeForm: FORMS.create })}>
                                <Translate id="Monitoring.Add.CreateNewPortfolio" />
                            </span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><Translate id="Monitoring.Add.Label" /></td>
                    <td>
                        <Field className="input" type="text" name="label" />
                    </td>
                </tr>
            </>
        );
    }

    renderCreateNewPortfolio = () => {
        return (
            <>
                <tr>
                    <td><Translate id="Monitoring.Add.PortfolioName" /></td>
                    <td>
                        <Field className="input" type="text" name="newPortfolio" />
                    </td>
                </tr>
                <tr>
                    <td><Translate id="Monitoring.Add.Label" /></td>
                    <td>
                        <Field className="input" type="text" name="label" />
                    </td>
                </tr>
            </>
        );
    }

    renderRemoveFromPortfolioForm = (setFieldValue) => {
        return (
            <tr>
                <td><Translate id="Monitoring.Add.SubjectInPortfolio" /></td>
                <td>
                    <BbSelectNoFormik
                        options={this.props.monitoring.addToPortfolioPopupData ? this.props.monitoring.addToPortfolioPopupData.listToRemove.map(c =>
                            ({ label: this.concatLabel(c.name, c.label), value: c.listId + "|" + c.id, key: c.listId + "|" + c.id })) : null}
                        onChange={(e) => setFieldValue("portfolioToRemove", e.value)}
                        selectPlaceholder={`${this.props.translate("Common.Select")} ...`}
                        noOptionsMessage={this.props.translate("Monitoring.NoPortfolios")}
                        isFixed={true}
                        style={this.selectStyle()}
                    />
                </td>
            </tr>
        );
    }

    replaceEm = val => {
        return val.replace(/<em>/g, "").replace(/<\/em>/g, "")
    }

    concatLabel = (name, label) => {
        var ret = name;
        if (label)
            ret += " (" + this.props.translate("Monitoring.Add.Label") + ": " + label + ")";
        return ret;
    }

    getData = () => {
        this.props.getAddToPortfolioPopupData(this.props.subject.entityId, this.props.subject.type === 1, this.props.subject.reports.primaryAttr, "", "");
    }

    removeSubject = (val) => {
        this.props.subjectFromPortfolioRemoved(val, this.props.subject.entityId, this.props.subject.type === 1, this.props.subject.reports.primaryAttr);
    }

    addSubject = (val, label, newPortfolio = null) => {
        if (val === null) {
            if (newPortfolio.length > 50) {
                this.setState({
                    validation: {
                        message: this.props.translate('Search.Common.Validation.WrongInput') +
                            " - " +
                            this.props.translate('Monitoring.Create.PortfolioName'),
                        messageType: "error"
                    }
                });
            }
            else {
                this.setState({
                    validation: {
                        message: null,
                        messageType: null
                    }
                });
                this.props.portfolioCreated(this.props.subject.entityId,
                    label,
                    this.props.subject.name,
                    this.props.subject.ico,
                    this.props.subject.dateOfBirth,
                    this.props.subject.type === 1,
                    this.props.subject.reports.primaryAttr,
                    newPortfolio);
            }
        } else {
            this.props.subjectToPortfolioAdded(this.props.subject.entityId, val, label, this.props.subject.name, this.props.subject.ico,
                this.props.subject.dateOfBirth, this.props.subject.type === 1, this.props.subject.reports.primaryAttr);
        }
    }
}


export default withLocalize(connect(
    state => state,
    dispatch => bindActionCreators(monitoringActions, dispatch)
)(AddToPortfolioPopup));